/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Remind_Digest_DietInputs */

const en_portal_remind_digest_diet = /** @type {(inputs: Portal_Remind_Digest_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diet: 2400 kcal`)
};

const pl_portal_remind_digest_diet = /** @type {(inputs: Portal_Remind_Digest_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieta: 2400 kcal`)
};

/**
* | output |
* | --- |
* | "Diet: 2400 kcal" |
*
* @param {Portal_Remind_Digest_DietInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_remind_digest_diet = /** @type {((inputs?: Portal_Remind_Digest_DietInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Remind_Digest_DietInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_remind_digest_diet(inputs)
	return en_portal_remind_digest_diet(inputs)
});